'use client';

import { Trans, useTranslation } from '@whoop/i18n/lang/client';
import SectionHeader from '../SectionHeader/SectionHeader';
export default function Warranty() {
  const {
    t
  } = useTranslation('joinLandingPage');
  return <div className='flex justify-center' data-sentry-component="Warranty" data-sentry-source-file="Warranty.tsx">
      <div className='max-w-screen-lg px-8 py-16 text-center'>
        <SectionHeader className='pb-6' data-sentry-element="SectionHeader" data-sentry-source-file="Warranty.tsx">{t('lifetimeWarranty')}</SectionHeader>
        <p className='pb-4' id='style-override-body-md'>
          {t('whoopDesigned')}
        </p>
        <Trans components={{
        privacy:
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        <a role='button' className='underline' href='https://whoop.com/privacy' key='app-link' rel='noopener' target='_blank' />
      }} i18nKey={t('readMore')} id='style-override-body-md' data-sentry-element="Trans" data-sentry-source-file="Warranty.tsx" />
      </div>
    </div>;
}